import { Box } from "@mui/material";
import i18next from "i18next";
import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../../../../components/dataTable/DataTable";
import styles from "./dealerTableSection.module.scss";
import _ from "lodash";
import TextBoxCompOne from "../../../../components/textBoxCompOne/TextBoxCompOne";
import StatusText from "../../../../components/statusText/StatusText";
import CustomPagination from "../../../../components/pagination/CustomPagination";
import { getStatusClassName } from "../../../../utils/commonFuntion";
import BulkActionMenu from "../../../../components/bulkActionMenu/bulkActionMenu";
import ActionComponent from "../actionComponent/ActionComponent";
import CustomSnackbar from "../../../../components/customSnackBar/CustomSnackbar";
import { useNavigate } from "react-router-dom";
import CustomModalDialog from "../../../../components/modal/CustomModalDialog";
import DeleteDealer from "../deleteDealerContent/DeleteDealer";
import {
  deleteDealer,
  removeDealer,
  updateDealerStatus,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import ChangeStatusComponent from "../../../../components/changeStatusComponent/ChangeStatusComponent";
import AssignGroup from "../../../Vehicles/components/assignGroupContent/AssignGroup";
import SelectedAssignedPopup from "../../../Vehicles/components/selectedAssignedGroup/SelectedAssignedPopup";

import EmailComponent from "../../../../components/emailComponent/EmailComponent";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

export function TooltipWrapper(val, styleval, size) {
  let width = 0;
  if (val?.length > 20 && val?.length < 25) {
    width = val?.length * 8;
  } else {
    width = val?.length * 7;
  }

  if (val?.length <= size) {
    return <Box className={styleval}>{val}</Box>;
  } else
    return (
      <Tooltip
        disableInteractive
        title={val}
        PopperProps={{
          sx: {
            "& .MuiTooltip-tooltip": {
              width: width,
              padding: "2px 0px",
              textAlign: "center",
              fontSize: "12px",
              color: "common.white",
              backgroundColor: "#808080",
              borderRadius: "5px",
            },
          },
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        }}
      >
        <Box className={styleval}>{`${String(val).slice(0, size)}.....`}</Box>
      </Tooltip>
    );
}
const DealerTableSection = (props) => {
  const {
    dealersList,
    snackBarMessage,
    openSnackbar,
    setOpenSnackbar,
    setSelectedDealerNo,
    setDetailsDrawerState,
    setEditDrawerState,
    searchKeyWord,
    pageSize,
    pageNumber,
    totalRecords,
    handlePageChange,
    handlePageSizeChange,
    refreshTable,
    onSortChange,
    sortModel = [],
    bulkActionMenuFlag,
    setBulkActionMenuFlag,
    selectionModel = [],
    setSelectionModal,
    isCheckboxSelection = true,
    setSnackAssignGroupMessage,
    setSearchFlag,
    selectedTab,
    inGroupTable,
  } = props;

  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);

  const [isShowModalFlag, setIsShowModalFlag] = useState(false);
  const [isShowAssignGroupModalFlag, setIsShowAssignGroupModalFlag] =
    useState(false);
  const [isSelectedAssigFlag, setIsSelectedAssigFlag] = useState(false);
  const [deleteDealerId, setDeleteDealerId] = useState(null);
  const [removeDealerId, setRemoveDealerId] = useState(null);
  const [isChangeStatus, setIsChangeStatus] = useState(false);
  const [isEmailOpen, setIsEmailOpen] = useState(false);
  const [snackBarCustomMessage, setSnackBarCustomMessage] = useState("");

  useEffect(() => {
    setSnackBarCustomMessage(snackBarMessage);
  }, [snackBarMessage]);

  const { setApiErrorModalState } = useApiErrorModalContext();
  const history = useNavigate();

  const handleDealerDelete = () => {
    deleteDealer({ dealerId: deleteDealerId })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDeleteDealerId(null);
          refreshTable();
          setIsShowModalFlag(false);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const handleDealerRemove = (id) => {
    removeDealer({ dealerId: id })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setRemoveDealerId(null);
          refreshTable();
          setIsShowModalFlag(false);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const handleDeleteBtnClick = (id) => {
    setDeleteDealerId(id);
    setIsShowModalFlag(true);
  };

  const handleRemoveBtnClick = (id) => {
    setRemoveDealerId(id);
    handleDealerRemove(id);
  };

  const onDealerClick = useCallback(
    (dealerNo) => {
      document.getElementById("contentWrapper").scrollIntoView = function () {};

      setSelectedDealerNo(dealerNo);
      setDetailsDrawerState(true);
    },
    [setDetailsDrawerState, setSelectedDealerNo]
  );

  const handleEditDrawer = useCallback(
    (dealerNo) => {
      document.getElementById("contentWrapper").scrollIntoView = function () {};

      setSelectedDealerNo(dealerNo);
      setEditDrawerState(true);
    },
    [setEditDrawerState, setSelectedDealerNo]
  );

  const handleCloseButtonClick = () => {
    setBulkActionMenuFlag(false);
    setSelectionModal([]);
  };

  const handelSelctdAssignBtnCLS = () => {
    setIsSelectedAssigFlag(false);
  };

  const AssignpopupDismiss = (values) => {
    setIsShowAssignGroupModalFlag(false);
    setSnackAssignGroupMessage(true);
    setOpenSnackbar(true);

    setSelectionModal([]);

    setTimeout(() => {
      setIsSelectedAssigFlag(false);
    }, 4000);
  };

  const handleStatusChange = (id, status, isViewDetails = false) => {
    setSearchFlag(true);
    updateDealerStatus({ dealerIds: [id], dealer_Status: status })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          refreshTable();
          if (isViewDetails) {
            handleEditDrawer(id);
          }
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const updateBulkActionFlag = (prevValue, currentValue) => {
    if (currentValue?.length >= 1) {
      if (!bulkActionMenuFlag) {
        // to avoid unwanted rendering
        setBulkActionMenuFlag(true);
      }
    } else if (currentValue?.length < 1) {
      if (bulkActionMenuFlag) {
        // to avoid unwanted rendering
        setBulkActionMenuFlag(false);
      }
    }
  };
 
  const onVehicleClick = useCallback(
    (vehicleDealerNumber, dealerSelectedTab) => {
      window.sessionStorage.setItem("searchKeyWord", searchKeyWord);
      const stateValues = {
        vehicleDealerNumber: vehicleDealerNumber,
        isBackButtonNeed:true,
        dealerSelectedTab
      };
      history(`/vehicles`, { state: stateValues });
    },
    [history, searchKeyWord]
  );

  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "dealer_Id",
        headerName: i18next.t("ID"),
        flex: 0.8,
        sortable: !_.isEmpty(dealersList),
        renderCell: (params) => (
          <TextBoxCompOne
            headerText={params.row?.dealer_Id}
            subText={`Exact nr.: ${params.row?.exactNumber}`}
          />
        ),
      },
      {
        field: "dealerName",
        headerName: i18next.t("Dealer"),
        flex: 2.2,
        sortable: !_.isEmpty(dealersList),
        renderCell: (params) => (
          <TextBoxCompOne
            hasStar={params.row?.isDealerGroup}
            headerText={TooltipWrapper(
              params.row?.dealerName,
              styles.dealerNameColumn,
              45
            )}
            subText={TooltipWrapper(
              `${params.row?.street} ${
                params.row?.houseNumber
              }, ${params.row?.postcode.toUpperCase().replace(/\s/g, "")} ${
                params.row?.city
              }`,
              styles.subText,
              45
            )}
            headerTextStyle={styles.dealerNameColumn}
            onheaderClick={() => onDealerClick(params.row?.dealer_Id)}
          />
        ),
      },
      {
        field: "status",
        headerName: i18next.t("Status"),
        flex: 0.9,
        sortable: !_.isEmpty(dealersList),
        renderCell: (params) => (
          <StatusText
            title={params.row?.status}
            customClass={getStatusClassName(params.row?.status)}
            hasIcon={true}
            data-testid="status"
            showPopover={true}
            defaultId={params.row?.dealer_Id}
            defaultStatus={params.row?.status}
            onStatusChange={handleStatusChange}
            hasSaveAndViewBtn={true}
            onSaveAndViewClick={(id, status) => {
              handleStatusChange(id, status, true);
            }}
            overview={true}
          />
        ),
      },
      {
        field: "certificateEmailId",
        headerName: i18next.t("Communication details"),
        flex: 1.15,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.communicationWrapper}>
            <Box className={styles.iconText}>
              <span className={styles.mailIcon}></span>
              {TooltipWrapper(
                params.row?.certificateEmailId,
                styles.iconText,
                15
              )}
            </Box>
            <Box className={styles.iconText}>
              <span className={styles.phoneIcon}></span>
              {params.row?.telephone}
            </Box>
          </Box>
        ),
      },
      {
        field: "source",
        headerName: i18next.t("Source, System"),
        flex: 1.0,
        sortable: !_.isEmpty(dealersList),
        renderCell: (params) => (
          <Box className={styles.sourceSystem}>
            <Box>{`${params.row?.source},`}</Box>
            <Box>{TooltipWrapper(
              params.row?.system,
              styles.sourceSystem,
              11
            )}</Box>
          </Box>
        ),
      },
      {
        field: "Province",
        sortable: !_.isEmpty(dealersList),

        headerName: (
          <Box className={styles.twoLineColumn}>{i18next.t("Province")}</Box>
        ),
        flex: 0.8,
        renderCell: (params) => (
          <span className={styles.lastUpdated}>{TooltipWrapper(
            params.row?.province,
            styles.lastUpdated,
            9
          )}</span>
        ),
      },
      {
        field: "noofvehicles",
        sortable: !_.isEmpty(dealersList),

        headerName: (
          <Box className={styles.twoLineColumn}>
            {i18next.t("No. of vehicles")}
          </Box>
        ),
        flex: 0.7,
        renderCell: (params) => (
          <Box
            className={styles.vehicleNbrText}
            onClick={() => {
              onVehicleClick(params.row?.dealer_Id, selectedTab)
            }}
            onKeyDown={() => {}}
          >
            {params.row?.noofvehicles}
          </Box>
        ),
      },
      {
        field: "sincelastvehicle",
        headerName: (
          <Box className={styles.twoLineColumn}>
            {i18next.t("Since last vehicle")}
          </Box>
        ),
        flex: 0.7,
        sortable: !_.isEmpty(dealersList),
        renderCell: (params) => (
          params.row?.noofvehicles > 0 ? 
          <Box className={styles.lastUpdated}>
            {params.row?.sincelastvehicle}
            <span className={styles.daysText}>{i18next.t("days")}</span>
          </Box> :
          <Box className={styles.lastUpdated}>
          
          <span className={styles.daysText}>n.v.t</span>
        </Box> 
        ),
      },

      {
        field: "activ",
        headerName: i18next.t("Actie"),
        flex: 0.4,
        sortable: false,
        renderCell: (params) => (
          <ActionComponent
            title={params.row?.status}
            hasIcon={false}
            dealerDetails={params.row}
            showPopover={true}
            handleDeleteClick={() => {
              handleDeleteBtnClick(params.row?.dealer_Id);
            }}
            handleRemoveClick={() => {
              handleRemoveBtnClick(params.row?.dealer_Id);
            }}
            inGroupTable={inGroupTable}
            content={
              <Box className={styles.inActiveStatusStyle}>
                <span className={styles.dotIcon}></span>
              </Box>
            }
          />
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);

    setTableColumnData(dealersList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealersList, onDealerClick, onVehicleClick]);

  return (
    <Box
      className={styles.dealerTableSectionWrapper}
      data-testid="DealerTableSection"
    >
      <DataTable
        columns={tableHeader}
        rows={tableColumnData}
        isShowMessage={true}
        isShowTableWhenNoResult={true}
        disableColumnMenu={true}
        disableColumnFilter={true}
        hideFooter={true}
        inGroupTable={false}
        isCheckboxSelection={isCheckboxSelection}
        disableRowSelectionOnClick={true}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setSelectionModal((prev) => {
            updateBulkActionFlag(prev, newRowSelectionModel);
            return newRowSelectionModel;
          });
        }}
        rowSelectionModel={selectionModel}
        onSortModelChange={(model) => onSortChange(model)}
        sortModel={sortModel}
      />
      <CustomSnackbar
        open={openSnackbar}
        message={snackBarCustomMessage}
        setOpen={setOpenSnackbar}
      />
      {isShowModalFlag ? (
        <CustomModalDialog
          title={"Delete selected dealers"}
          isShow={isShowModalFlag}
          onClose={() => setIsShowModalFlag(false)}
          className={"modal-dialog"}
          isCloseButton={true}
          hasFooter={false}
        >
          <DeleteDealer
            handleDelete={handleDealerDelete}
            handleCancel={() => setIsShowModalFlag(false)}
            primaryMessage ={i18next.t("Are you sure you want to delete the selected dealers?")}
            secondaryMessage= {i18next.t("You cannot retrieve it back")}
          />
        </CustomModalDialog>
      ) : (
        ""
      )}

      {bulkActionMenuFlag && selectionModel.length > 0 ? (
        <BulkActionMenu
          btnlist={[
            {
              title: "Email",
              iconStyle: "email",
              buttonType: "muibtn-menu-with-icon",
              withIcon: true,
              handleClick: () => {
                setIsEmailOpen(true);
              },
            },
            {
              title: "Assign group",
              iconStyle: "assign",
              buttonType: "muibtn-menu-with-icon",
              withIcon: true,
              handleClick: () => {
                setIsShowAssignGroupModalFlag(true);
              },
            },
            {
              title: "Change status",
              iconStyle: "",
              buttonType: "muibtn-menu-with-icon",
              withIcon: false,
              handleClick: () => {
                setIsChangeStatus(true);
              },
            },
          ]}
          selectionModel={selectionModel}
          handleCloseButtonClick={handleCloseButtonClick}
          onRowSelectionModelChange={(newRowSelectionModel) => {
            setSelectionModal((prev) => {
              updateBulkActionFlag(prev, newRowSelectionModel);
              return newRowSelectionModel;
            });
          }}
        />
      ) : null}
      {isShowAssignGroupModalFlag ? (
        <CustomModalDialog
          title={i18next.t("Assign dealers to group")}
          isShow={isShowAssignGroupModalFlag}
          onClose={() => {
            setIsShowAssignGroupModalFlag(false);
            setSelectionModal([]);
          }}
          className={"modal-dialog"}
          isCloseButton={true}
          hasFooter={false}
          primaryBtnLabel="Assign to group"
          primaryButnFn={() => alert("assignGroupButton")}
        >
          <AssignGroup
            groupCount={selectionModel.length}
            handleSubmit={AssignpopupDismiss}
            selectionModel={selectionModel}
            // setSnackBarCustomMessage={setSnackBarCustomMessage}
            // setOpenSnackbar={setOpenSnackbar}
          />
        </CustomModalDialog>
      ) : (
        ""
      )}
      {isSelectedAssigFlag ? (
        <SelectedAssignedPopup
          handleCloseButtonClick={handelSelctdAssignBtnCLS}
        />
      ) : (
        ""
      )}
      {!_.isEmpty(dealersList) && pageSize < totalRecords ? (
        <CustomPagination
          row={tableColumnData}
          paginationResult={{
            pageSize: pageSize,
            pageNumber: pageNumber,
            totalRecords: totalRecords,
          }}
          setCurrentPageNumber={handlePageChange}
          showRowPerPage={false}
          setCurrentPageSize={handlePageSizeChange}
        />
      ) : null}

      {isChangeStatus ? (
        <CustomModalDialog
          title={i18next.t("Change status")}
          isShow={isChangeStatus}
          onClose={() => {
            setIsChangeStatus(false);
            setSelectionModal([]);
          }}
          className={"change status"}
          isCloseButton={true}
          hasFooter={false}
        >
          <ChangeStatusComponent
            selectionModel={selectionModel}
            setSelectionModal={setSelectionModal}
            setBulkActionMenuFlag={setBulkActionMenuFlag}
            setChangeStatus={setIsChangeStatus}
            refreshTable={refreshTable}
          />
        </CustomModalDialog>
      ) : null}

      {isEmailOpen ? (
        <CustomModalDialog
          title={i18next.t("Bulk email")}
          isShow={isEmailOpen}
          onClose={() => {
            setIsEmailOpen(false);
            setSelectionModal([]);
          }}
          className={"bulkEmailPreview"}
          isCloseButton={true}
          hasFooter={false}
        >
          <EmailComponent
            selectionModel={selectionModel}
            setSelectionModal={setSelectionModal}
            setEmailOpen={setIsEmailOpen}
            setBulkActionMenuFlag={setBulkActionMenuFlag}
            setSnackBarCustomMessage={setSnackBarCustomMessage}
            setOpenSnackbar={setOpenSnackbar}
          />
        </CustomModalDialog>
      ) : null}
    </Box>
  );
};
export default DealerTableSection;
DealerTableSection.propTypes = {
  dealersList: PropTypes.any,
  snackBarMessage: PropTypes.any,
  openSnackbar: PropTypes.any,
  setOpenSnackbar: PropTypes.any,
  setSelectedDealerNo: PropTypes.any,
  setDetailsDrawerState: PropTypes.any,
  setEditDrawerState: PropTypes.any,
  pageSize: PropTypes.any,
  pageNumber: PropTypes.any,
  totalRecords: PropTypes.any,
  handlePageChange: PropTypes.any,
  handlePageSizeChange: PropTypes.any,
  refreshTable: PropTypes.any,
  onSortChange: PropTypes.any,
  sortModel: PropTypes.any,
  bulkActionMenuFlag: PropTypes.any,
  setBulkActionMenuFlag: PropTypes.any,
  selectionModel: PropTypes.any,
  setSelectionModal: PropTypes.any,
  isCheckboxSelection: PropTypes.any,
  setSnackAssignGroupMessage: PropTypes.any,
  setSearchFlag: PropTypes.any,
  searchKeyWord: PropTypes.any,
  selectedTab: PropTypes.any
};
